
/*
    API requests to get the data for the various reports within the application:
    - Reassignment
    - Quarterly
    - Trip on Time
    - Starter Sheet

    - and for PDF exports of each
*/

import axios from "axios";
import BaseValues from "./BaseValues";

import { formatDateTime } from "../Scripts/Utilities";

//
// helper function for exporting data to a PDF file created on the server,
// and then automatically downloading it to the user's browser
//
function runPDFExport(data, url, reportName){
    console.log("PDF Export", url, reportName, data);
    return axios.post(url,
        data,
        {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/pdf'
            }
        })
        .then((response) => {
            console.log("PDF RESPONSE PDF RESPONSE", response);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            // off the screen
            link.style.position = "absolute";
            link.style.top = "-100px";
            link.href = url;
            link.setAttribute('download', `${reportName}.pdf`); //or any other extension
            document.body.appendChild(link);
            link.click();
        })
        .catch((error) => console.log(error));
}

//
// retrieve data for the reassignment report matching the given filter
//
export const getReassignmentReport = (params) => {

    /*
location: "ALL",
        startDate: new Date(),
        endDate: new Date(),
        startTime: "00:00",
        endTime: "23:59",
        showAllTrips: false,
        driverReassigned: false,
        starterReassigned: true,
        routes: [],
        routesSelected: "ALL",
        runs: [],
        runsSelected: "ALL",
        vehicleIDs: [],
        vehicleIDsSelected: "ALL",
        lanes: [],
        lanesSelected: "ALL"
    */

    const data = BaseValues.createFormData({
        location: params.location,
        trip_number: params.trip_number,
        vehicleId: params.vehicleId,
        route: params.routesSelected.join(",") || "", // "ALL",
        runid: params.runsSelected.join(",") || "", // "ALL",
        gate: (params.lanesSelected && params.lanesSelected.join) ? params.lanesSelected.join(",") : "ALL",
        // driver: params.driverReassigned ? "true" : "false",
        starter: params.starter,
        fromdate: BaseValues.createDateString(params.startDate) + " " + params.startTime,
        todate: BaseValues.createDateString(params.endDate) + " " + params.endTime
    });

    const url = `${BaseValues.BaseURL}/api/reports/getReassignmentReport`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// get the data for the reassignment report and redirect the output to a PDF
//
export const getReassignmentReportPDF = (params) => {

    /*
location: "ALL",
        startDate: new Date(),
        endDate: new Date(),
        startTime: "00:00",
        endTime: "23:59",
        showAllTrips: false,
        driverReassigned: false,
        starterReassigned: true,
        routes: [],
        routesSelected: "ALL",
        runs: [],
        runsSelected: "ALL",
        vehicleIDs: [],
        vehicleIDsSelected: "ALL",
        lanes: [],
        lanesSelected: "ALL"
    */

    const data = BaseValues.createFormData({
        location: params.location,
        route: params.routesSelected ? params.routesSelected.join(",") : "ALL",
        runid: params.runsSelected ? params.runsSelected.join(",") : "ALL",
        gate: (params.lanesSelected && params.lanesSelected.join) ? params.lanesSelected.join(",") : "ALL",
        driver: params.driverReassigned ? "true" : "false",
        starter: params.starterReassigned ? "true" : "false",
        fromdate: BaseValues.createDateString(params.startDate) + " " + params.startTime,
        todate: BaseValues.createDateString(params.endDate) + " " + params.endTime
    });

    const pdfURL = "";
    return runPDFExport(data, pdfURL, "ReassignmentReportExport");
}

//
// retrieve data for the quarterly report matching the given filter
//
export const getQuarterlyReport = (params) => {
    console.log("quarterly report params", params);

    const data = BaseValues.createFormData({
        fromdate: BaseValues.createDateString(params.startDate),
        todate: BaseValues.createDateString(params.endDate)
    });

    const url = `${BaseValues.BaseURL}/api/reports/getQuarterlyOTPReport`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// get the quarterly report data and redirect the output to a PDF
//
export const getQuarterlyReportPDF = (params) => {
    console.log("quarterly report params", params);

    const data = BaseValues.createFormData({
        fromdate: BaseValues.createDateString(params.startDate),
        todate: BaseValues.createDateString(params.endDate)
    });

    const pdfURL = `${BaseValues.BaseURL}/api/reports/getQuarterlyReportsPDF`;
    return runPDFExport(data, pdfURL, "QuarterlyReportExport");
}

//
// retrieve data for the trip on time report matching the given filter
// this could be one of many reports, based on mode
//
export const getTripOnTimeReport = (params, mode) => {

    console.log("params", params);

    const data = BaseValues.createFormData({
        location: params.location,
        route: params.routesSelected.join ? params.routesSelected.join(",") : "ALL",
        showdate: params.showDailyResult ? "true" : "false",
        useclever: params.useRealTime ? "true" : "false",
        wkday: params.weekdays ? "true" : "false",
        wkend: params.weekends ? "true" : "false",
        fromdate: BaseValues.createDateString(params.startDate) + " " + params.startTime,
        todate: BaseValues.createDateString(params.endDate) + " " + params.endTime
    });

    let url = `${BaseValues.BaseURL}/api/reports`;

    switch(mode){
        case "Location":
            url = `${url}/getOnTimeReportsTotals`
            break;
        case "Garage":
            url = `${url}/getOnTimeReportsByGarage`
            break;
        case "Route":
            url = `${url}/getOnTimeReportsByRoute`
            break;
        case "Run":
            url = `${url}/getOnTimeReportsByRun`
            break;
        case "Lane":
            url = `${url}/getOnTimeReportsByLane`
            break;
        case "User":
            url = `${url}/getOnTimeReportsByEmp`
            break;
        case "Delays":
            url = `${url}/getDelayReasonsReport`
            break;
        default:
            ;
    }

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// get trip on time data and redirect the output to a PDF
//
export const getTripOnTimeReportPDF = (params, modes) => {

    console.log("GET TRIP ON TIME REPORT");
    console.log("params", params);

    const data = BaseValues.createFormData({
        location: params.location,
        route: params.routesSelected.join ? params.routesSelected.join(",") : "ALL",
        showdate: params.showDailyResult ? "true" : "false",
        useclever: params.useRealTime ? "true" : "false",
        wkday: params.weekdays ? "true" : "false",
        wkend: params.weekends ? "true" : "false",
        fromdate: BaseValues.createDateString(params.startDate) + " " + params.startTime,
        todate: BaseValues.createDateString(params.endDate) + " " + params.endTime,
        subreports: modes.join(",")
    });

    const pdfURL = `${BaseValues.BaseURL}/api/reports/getOnTimeReportsPDF`; 
    return runPDFExport(data, pdfURL, "TripOnTimeReportExport");
}

//
// retrieve data for the starter sheet report matching the given filter
//
export const getStarterSheetReport = (params) => {

    console.log("STARTER SHEET REPORT");

    let employee = "ALL";

    if(params.employeeSelected !== "-1") {
        employee = params.employeeSelected;
    }

    const data = BaseValues.createFormData({
        location: params.location,
        route: params.routesSelected.join(",") || "ALL",
        runid: params.runsSelected.join(",") || "ALL",
        gate: (params.lanesSelected && params.lanesSelected.join) ? params.lanesSelected.join(",") : "ALL",
        employee: employee, // employees,
        alltrips: params.showAllTrips ? "true" : "false",
        fromdate: BaseValues.createDateString(params.startDate) + " " + params.startTime,
        todate: BaseValues.createDateString(params.endDate) + " " + params.endTime
    });

    const url = `${BaseValues.BaseURL}/api/reports/getStarterSheetReport`;

    console.log("STARTER SHEET URL", url);

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// get data summarizing/aggregating the starter sheet report
//
export const getStarterSummary = (params) => {

    console.log("STARTER SHEET REPORT SUMMARY");

    let employee = "ALL";

    if(params.employeeSelected !== "-1") {
        employee = params.employeeSelected;
    }

    const data = BaseValues.createFormData({
        location: params.location,
        route: params.routesSelected.join(",") || "ALL",
        runid: params.runsSelected.join(",") || "ALL",
        gate: (params.lanesSelected && params.lanesSelected.join) ? params.lanesSelected.join(",") : "ALL",
        employee: employee, // employees,
        alltrips: params.showAllTrips ? "true" : "false",
        fromdate: BaseValues.createDateString(params.startDate) + " " + params.startTime,
        todate: BaseValues.createDateString(params.endDate) + " " + params.endTime
    });

    const url = `${BaseValues.BaseURL}/api/reports/getStarterSheetReportTotals`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}

//
// get the starter sheet data and redirect the output to a PDF
//
export const getStarterSheetPDF = (params) => {

    console.log("TEST GETTING A PDF", params);

    // hmm, not sure if this is required anymore...
    let employees = "ALL";
    if(params.employeesSelected && params.employeesSelected.length > 0){
        employees = params.employeesSelected.map(e => {
            return e.id;
        }).join(",");
    }
    else if(params.employeesSelected && typeof params.employeesSelected === "string"){
        employees = params.employeesSelected;
    }

    const innerParams = {
        location: params.location,
        route: params.routesSelected.join(",") || "ALL",
        runid: params.runsSelected.join(",") || "ALL",
        gate: (params.lanesSelected && params.lanesSelected.join && params.lanesSelected.length) ? params.lanesSelected.join(",") : "ALL",
        employee: employees,
        alltrips: params.showAllTrips ? "true" : "false",
        fromdate: BaseValues.createDateString(params.startDate) + " " + params.startTime,
        todate: BaseValues.createDateString(params.endDate) + " " + params.endTime
    };

    const data = BaseValues.createFormData(innerParams);

    const url = `${BaseValues.BaseURL}/api/reports/getStarterSheetReportPDF`;

    console.log("TEST PDF PARAMETERS", innerParams, data, url);

    return runPDFExport(data, url, "StarterSheetExport");
}


//
// edit an individual record in the starter sheet report
//
export const submitEditedStarterEntry = (params) => {

    console.log("submitEditedStarterEntry", params);

    // helper function for properly handling values set to be blank, as opposed to ignored
    const replaceAsBlank = (val) => {
        return val === "" ? "BLANK" : val;
    }

    console.log("SUBMIT EDITED: DEPARTURE VALUE", params.passDeparture);

    const translation = {
        timepoint: params.TimingPointID,
        scheddeptime: formatDateTime(params.SchedDepTime),
        // actual_departure_time: formatDateTime(params.SchedDepTime, params.time),
        ActDepTime: (params.SchedDepTime !== params.ActDepTime && params.ActDepTime !== "") ? formatDateTime(params.SchedDepTime, params.ActDepTime) : "",
        internal_trip_number: params.InternalTripNumber,
        lane: params.ManualLaneGate ? params.ManualLaneGate : params.SchedLaneGate,
        vehicle_id: params.VehicleId,
        pass_on_arrival: replaceAsBlank(params.passArrival),
        pass_getting_off: replaceAsBlank(params.passGetOff),
        pass_boarding: replaceAsBlank(params.passBoarding),
        pass_left_behind: replaceAsBlank(params.passLeftBehind),
        pass_on_departure: replaceAsBlank(params.passDeparture),
        delay_reason: "",
        delay_comment: "",
        manual_delay: ""
    };

//     ActDepTime: "02:05"
// Clever: ""
// CleverColor: ""
// Color: ""
// DepTime: "4:05 A"
// Dest: "ACBarr"
// Diff: ""
// InternalTripNumber: "16007299"
// LaneGate: "7"
// Line: "551"
// RTN: "540A /551"
// Run: "4"
// SchedDate: "09-DEC-20"
// SchedDepTime: "12/9/2020 4:05:00 AM"
// TimingPointID: "WRBWIN"
// VehicleColor: "Black"
// VehicleId: "222"
// passArrival: ""
// passArriving: "2"
// passBoarding: "2"
// passDeparture: ""
// passGetOff: ""
// passGettingOff: "1"
// passLeftBehind: ""

    console.log("UPDATE TRANSLATION", translation);

    const data = BaseValues.createFormData(translation);
    
    const url = `${BaseValues.BaseURL}/api/BUSConsole/updatetrip`;

    var config = {
        method: 'post',
        url,
        data
    };

    return axios(config).catch(BaseValues.handleError);
}